import React, { useCallback } from 'react'
import Link from 'redux-first-router-link'
import Menu from '@groovehq/internal-design-system/lib/components/Menu/Menu'

import SearchRawCount from '../SearchRawCount'
import Item from '../Item'
import Group from '../Group'
import AvailabilityStatus from '../AvailabilityStatus'
import { styles } from './styles'

export default function FolderCollection({
  collectionId,
  name,
  color,
  queryId,
  linkTo,
  open,
  onClick,
  itemAndGroupIds,
  hideName,
}) {
  const handleClick = useCallback(
    evt => {
      if (onClick) onClick(collectionId, evt)
    },
    [onClick, collectionId]
  )

  return (
    <Menu.UnmanagedItem
      key={collectionId}
      as={Link}
      to={linkTo}
      onClick={handleClick}
      open={open}
      count={<SearchRawCount queryId={queryId} />}
      dotColor={color}
      className="grui items-baseline py-5 -mb-3"
      css={styles.base}
      subMenu={
        <>
          {itemAndGroupIds.map(({ id: listId, type }) => {
            if (type === 'item') {
              return <Item key={listId} itemId={listId} isSubMenuItem />
            }
            if (type === 'group') {
              return <Group key={listId} groupId={listId} />
            }
            return null
          })}
        </>
      }
    >
      {!hideName && (
        <>
          {name}
          <AvailabilityStatus widgetId={collectionId.replace(/wid_/, '')} />
        </>
      )}
    </Menu.UnmanagedItem>
  )
}
